import {
  Alert,
  AlertDescription,
  AlertIcon,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Icon,
  Input,
  Text,
  VStack,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import Nav from "../components/nav/Nav";
import Container from "../components/Container";
import { useFormik } from "formik";
import * as yup from "yup";
import RequiredForm from "../components/form/RequiredForm";
import cr from "../lib/request";
import { CheckCircle } from "@phosphor-icons/react";

export default function ResetPassword() {
  const [loading, setLoading] = useState<boolean>(false);
  const [emailSent, setEmailSent] = useState<boolean>(false);
  const toast = useToast();

  const formik = useFormik({
    validateOnChange: false,

    initialValues: {
      email: "",
    },

    validationSchema: yup.object().shape({
      email: yup.string().required("Email harus diisi"),
    }),

    onSubmit: (values, { resetForm }) => {
      setLoading(true);
      const url = `api/usercourse/forgotpassword`;
      const payload = {
        email: values.email,
      };
      cr.post(url, payload)
        .then((r) => {
          if (r.status === 200) {
            setEmailSent(true);
          }
        })
        .catch((e) => {
          console.log(e);
          if (e?.response?.status === 404) {
            toast({
              title: e?.response?.data?.message,
              status: "error",
              duration: 5000,
              isClosable: true,
            });
          } else if (e?.response?.status === 422) {
            toast({
              title: "Input tidak valid",
              status: "error",
              duration: 5000,
              isClosable: true,
            });
          } else {
            toast({
              title: "Maaf terjadi kesalahan",
              status: "error",
              duration: 5000,
              isClosable: true,
            });
          }
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  return (
    <VStack gap={0} w={"100%"}>
      <Nav />

      <Container>
        <VStack
          p={5}
          w={"100%"}
          maxW={!emailSent ? "500px" : "800px"}
          align={"stretch"}
          mx={"auto"}
        >
          {!emailSent ? (
            <>
              <Text fontWeight={600} fontSize={24} mb={2}>
                Reset Password
              </Text>

              <Alert
                minW={"100% !important"}
                status="warning"
                variant={"left-accent"}
                mb={4}
                alignItems={"flex-start"}
              >
                <AlertIcon />
                <AlertDescription mt={0} lineHeight={"1.4 !important"}>
                  Masukkan email yang terdaftar, jika terdaftar maka kami akan
                  mengirim tautan reset password ke email anda.{" "}
                  <b>
                    Link hanya dapat digunakan 1 kali. Jaga link tersebut,
                    karena kelalaian bukan tanggung jawab kami.
                  </b>
                </AlertDescription>
              </Alert>

              <form
                id="resetPasswordCekEmailForm"
                onSubmit={formik.handleSubmit}
              >
                <FormControl
                  mb={4}
                  isInvalid={formik.errors.email ? true : false}
                >
                  <FormLabel>
                    Email Check
                    <RequiredForm />
                  </FormLabel>
                  <Input
                    name="email"
                    placeholder="Masukkan email"
                    onChange={formik.handleChange}
                  />
                  <FormErrorMessage>{formik.errors.email}</FormErrorMessage>
                </FormControl>
              </form>

              <Button
                type="submit"
                form="resetPasswordCekEmailForm"
                colorScheme="ap"
                className="clicky"
                isLoading={loading}
              >
                Cek Email
              </Button>
            </>
          ) : (
            <VStack p={10} w={"100%"}>
              <Icon
                as={CheckCircle}
                fontSize={150}
                weight={"thin"}
                color={"p.500"}
              />
              <Text
                fontSize={32}
                fontWeight={600}
                color={"p.500"}
                textAlign={"center"}
              >
                Tautan reset password telah dikirim di email{" "}
                {formik.values.email}
              </Text>
              <Text fontSize={20} textAlign={"center"}>
                Silahkan cek email anda
              </Text>
            </VStack>
          )}
        </VStack>
      </Container>
    </VStack>
  );
}
